import type { AxiosInstance } from 'axios';
import {
  SignInInput,
  SignInResponse,
  RefreshTokenInput,
  InitiateResetPasswordInput,
  InitiateResetPasswordResponse,
  ConfirmResetPasswordInput,
  Role,
} from './types';

export class AuthService {
  instance: AxiosInstance;

  tokenType = 'Bearer';

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async signIn(input: SignInInput): Promise<SignInResponse> {
    const response = await this.instance.post<SignInResponse>('/auth/login', {
      email: input.email,
      password: input.password,
      roles: [Role.Admin, Role.Physician, Role.SuperUser, Role.EventManager],
    });
    // eslint-disable-next-line no-console
    console.log('response', response);
    const { data } = response;
    if (!data?.idToken?.jwtToken) {
      throw data;
    }
    // TODO: Change to auth.accessToken from auth.idToken when
    // backend API already addressed the token mismatch issue.
    this.instance.defaults.headers.common.Authorization = `${this?.tokenType} ${data?.idToken?.jwtToken}`;
    return data;
  }

  async refreshToken(input: RefreshTokenInput): Promise<SignInResponse> {
    const response = await this.instance.post<SignInResponse>(
      '/auth/refresh-token',
      {
        email: input.email,
        refreshToken: input.refreshToken,
      },
    );
    const { data } = response;
    // TODO: Change to auth.accessToken from auth.idToken when
    // backend API already addressed the token mismatch issue.
    this.instance.defaults.headers.common.Authorization = `${this.tokenType} ${data.idToken.jwtToken}`;
    return data;
  }

  async initiatePasswordReset(
    input: InitiateResetPasswordInput,
  ): Promise<void> {
    await this.instance.post<InitiateResetPasswordResponse>(
      '/auth/forgotPassword',
      input,
    );
  }

  async confirmPasswordReset(input: ConfirmResetPasswordInput): Promise<void> {
    await this.instance.post('/auth/resetPassword', input);
  }
}
